module.exports = __webpack_public_path__ + "51a3624792cc44a11ab6fc067b051891.MP3";